import { createSharedSlice } from '@luna/state';

interface State {
    imageBase64?: string;
    imageBigBase64?: string;
}

const INITIAL_STATE: State = {
    imageBase64: undefined,
    imageBigBase64: undefined,
};

export const useProfileImage = createSharedSlice({
    name: 'shared/profile-image',
    initialState: { ...INITIAL_STATE },
    reducers: {
        setImageBase64: (state, action: { payload?: string }) => {
            state.imageBase64 = action.payload;
        },
        setImageBigBase64: (state, action: { payload?: string }) => {
            state.imageBigBase64 = action.payload;
        },
    },
});
